import * as React from 'react';
import { Alert } from 'reactstrap';
import { NavLink } from 'react-router-dom';

/**
 * Lockout component
 *
 * React component responsible for handling lockout.
 *
 * @class Lockout
 * @extends {React.SFC}
 */
const Lockout: React.SFC = () => {
	return (
		<div className="login-form">
			<Alert color="danger">
				This account has been locked out, please try again later.{' '}
				<NavLink to="/login" exact activeClassName="active">
					Click here to go back to login.
				</NavLink>
			</Alert>
		</div>
	);
};

export default Lockout;
